'use client';
import { useTantoSvagoStore } from '@/store';
import clsx from 'clsx/lite';
import Container from '@/app/_components/container';
import { useIsWelfare } from '@/app/_hooks/useIsWelfare';
import HeaderTantosvago from '@/app/_components/layouts/headerTantosvago';
import { HeaderLogo } from '@/app/_components/layouts/headerV2/headerLogo';
import { HeaderActions } from '@/app/_components/layouts/headerMenu';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Suspense } from 'react';
import Searchbar from '@/app/_components/searchbar';
import { useIsApp, postMessageToApp } from '@/app/_hooks/useIsApp';

type HeaderType = 'full' | 'only-logo';

type HeaderProps = React.PropsWithChildren & {
  shouldShowTantoSvago?: boolean;
  keepQueryParams?: boolean;
  type: HeaderType;
  defaultService?: string;
  scrollSearch?: boolean;
};

const Header = ({
  shouldShowTantoSvago = false,
  type: _type,
  keepQueryParams = false,
  defaultService,
  scrollSearch = false,
}: HeaderProps) => {
  const isApp = useIsApp();
  const type: HeaderType = isApp ? 'only-logo' : _type;

  const { userInfo, logoImageUrl, callbackUrl } = useTantoSvagoStore();
  const hasWelfareToken = useIsWelfare();
  const isWelfare = hasWelfareToken && shouldShowTantoSvago;

  return (
    <header className="sticky left-0 top-0 z-[250] min-h-12 w-full" id="header-elty" data-cy="header">
      {isWelfare && (
        <HeaderTantosvago
          name={userInfo.firstName}
          surname={userInfo.lastName}
          logo={logoImageUrl}
          onGoBack={() => (window.location.href = new URL(callbackUrl).href)}
        />
      )}

      <Container className={clsx('bg-neutral-surface shadow-header')} childrenClassName="py-3">
        {type === 'full' && (
          <>
            <div className="flex items-center justify-between ">
              <HeaderLogo type="full" isApp={isApp} />
              <div className="hidden max-w-[600px] flex-1 items-center lg:flex 2xl:max-w-[800px]">
                <div className="hidden w-full md:block" data-cy="header-searchbar">
                  <Suspense>
                    <Searchbar keepQueryParams={keepQueryParams} idPrefix="headerSearchBarDesktop" defaultService={defaultService} inline />
                  </Suspense>
                </div>
              </div>
              <HeaderActions searchType={scrollSearch ? 'scroll' : 'popover'} defaultService={defaultService} />
            </div>
          </>
        )}
        {type === 'only-logo' && (
          <>
            <div className="grid grid-cols-[24px_1fr_24px] items-center">
              {isApp ? (
                <button onClick={() => postMessageToApp(JSON.stringify({ type: 'goBack' }))} className="size-8 p-1">
                  <ChevronLeftIcon className="cursor-pointer text-primary" />
                </button>
              ) : (
                <div />
              )}
              <div className="flex max-h-full w-full max-w-full items-center justify-center">
                <HeaderLogo type="full" isApp={isApp} />
              </div>
            </div>
          </>
        )}
      </Container>
    </header>
  );
};

export default Header;
